import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapJsonQuery } from '../../mappers';

import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TReduxActions } from '../../types/redux';

const defaultState: IJsonQuery = {};

export function jsonQueryReducer(state: IJsonQuery = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapJsonQuery(action.payload.jsonQuery);
  }

  return state;
}
